
export default {
  name: 'BmrCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What is a good BMR for my age?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "For men between the ages of 30 and 39, the ideal BMR is 39.5. This number is 36.5 for women. Meanwhile, men and women aged 40 - 49 will have a BMR of 38.5 and 36.5, respectively, slightly lower than people aged 30 - 39."
        }
      },{
        "@type": "Question",
        "name": "What is the BMR average?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "On average, a man will have a BMR of about 7,100 kJ/24 hours. It is about 5,900 kJ/24 hours for women."
        }
      },{
        "@type": "Question",
        "name": "Which basal metabolic rate calculator is best?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Mifflin-St Jeor is a highly accurate, widely used calculation formula. Yet, it will be more precise to use with thinner people."
        }
      },{
        "@type": "Question",
        "name": "What is the ideal BMR for females?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The ideal women's BMR is in the range of 1550 calories per day. This number will vary depending on her health status and lifestyle habits."
        }
      },{
        "@type": "Question",
        "name": "How do I calculate my BMR for weight loss?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can find the BMR calculator to lose weight. You can also use the following formula to calculate your BMR: Men's BMR results from the calculation: 10W + 6.25 H - 5A + 5. Women's BMR results from the analysis: 10W + 6.25 H - 5A - 161."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        age: 25,
        gender: 'male',
        unit: 'metric',
        height_metric: 175,
        weight_metric: 70,
        height_us_feet: 5,
        height_us_inch: 10,
        weight_us: 160,
        level: 1.465
      })
    }
  },
  methods: {
    onBmrCalculator() {
        this.form.post(`/tool/bmr-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
